import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

function Success({ showToast, setShowToast, toastMessage }) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!showToast) return;

    setProgress(100);

    const duration = 4000; // 4 seconds
    const intervalTime = 20;
    const decrement = 100 / (duration / intervalTime);

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev <= 0) {
          clearInterval(interval);
          setShowToast(false);
          return 0;
        }
        return prev - decrement;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [showToast, setShowToast]);

  const closeToast = () => {
    setShowToast(false);
    setProgress(0);
  };

  if (!showToast) return null;

  return (
    <div className="toast-wrapper">
      <div className="toast-card">
        <div className="toast-body">
          <span>{toastMessage}</span>
          <FaTimes className="toast-close" onClick={closeToast} />
        </div>

        <div className="toast-progress">
          <div
            className="toast-progress-bar"
            style={{ width: `${Math.max(progress, 0)}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default Success;